var data = {
  "body": "<path d=\"M16 .011C7.099.011.011 7.099.011 16S7.099 31.995 16 31.995S31.989 24.902 31.989 16S24.901.011 16 .011zM3.484 16.14l12.38 12.376c-6.817 0-12.38-5.563-12.38-12.376zm15.297 12.1L3.765 13.219C5.016 7.656 10.021 3.484 16 3.484a12.635 12.635 0 0 1 10.151 5.147l-1.807 1.531a10.21 10.21 0 0 0-8.48-4.453a10.081 10.081 0 0 0-9.599 6.819L19.338 25.6c3.197-1.115 5.703-3.896 6.396-7.235h-5.423v-2.364h8.204c0 5.979-4.172 10.989-9.735 12.24z\" fill=\"currentColor\"/>",
  "width": 32,
  "height": 32
};
exports.__esModule = true;
exports["default"] = data;